import { computed, ref } from 'vue'

/**
 * @import { Ref } from 'vue'
 * @import { Emits } from './emitTypes.js'
 * @import { Department } from '../Suggest/useDepartmentList.js'
 */

/**
 * @param {string} defaultValue
 * @param {Ref<Array<Department>>} itemList
 * @param {Emits<Array<Department>>} emits
 */
export const useDepartmentSelection = (defaultValue, itemList, emits) => {
  /** @type {Ref<string>} */
  const value = ref(defaultValue)
  /** @type {Ref<Array<Department>>} */
  const departmentList = ref(itemList)
  /** @type {Ref<boolean>} */
  const focused = ref(false)

  const openSuggestions = computed(() => {
    return itemList.value.length > 0 && focused.value
  })

  /**
   * @param {Department} selection
   */
  const onClickOption = selection => {
    emits('selectionChange', selection)
    value.value = selection.text
  }

  /**
   * @param {boolean} value
   * @param {boolean} isAbroad
   */
  const onFocusEvent = (value, isAbroad) => {
    focused.value = value
    if (value && !isAbroad) {
      emits('inputChange', '')
      emits('textChange', '')
    }
  }

  /**
   *
   * @param {Event} event
   */
  const onInput = event => {
    const v = /** @type {HTMLInputElement|null} */ (event.target)?.value ?? ''
    value.value = v
    emits('inputChange', v)
  }

  /** */
  const clearValue = () => {
    value.value = ''
  }

  /**
   *
   * @param {Event} event
   */
  const onChange = event => {
    const v = /** @type {HTMLInputElement|null} */ (event.target)?.value ?? ''
    value.value = v
    emits('textChange', v)
  }

  return {
    value,
    departmentList,
    openSuggestions,
    onClickOption,
    onFocusEvent,
    onInput,
    clearValue,
    onChange,
  }
}
